import { isEqual } from 'lodash';
import { AppThunk } from '../../../store/rootReducer';
import { stripByIdSelector } from '../../plot/selectors/strip.selectors';
import * as createActions from '../actions/create.actions';
import { currentLeadsSelector } from '../selectors/create.selectors';

export const setCurrentLeads = (stripId: string): AppThunk => (
  dispatch,
  getState,
) => {
  const strip = stripByIdSelector(stripId)(getState());
  const currentLeads = currentLeadsSelector(getState());

  if (
    strip == null ||
    strip.leads.length === 0 ||
    isEqual(currentLeads, strip.leads)
  ) {
    return;
  }

  dispatch(
    createActions.setLeads({ leads: strip.leads, meta: { history: false } }),
  );
};
